import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { useBreakpointValue, useDisclosure } from '@chakra-ui/react';
import CUIHamburgerIcon from 'connect-dot-com-ui-components/Components/Icons/CUIHamburgerIcon';
import MobileNavDrawerContent from './MobileNavDrawerContent';
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import { CUIDrawer, CUIDrawerOverlay } from 'connect-dot-com-ui-components/Components/CUIDrawer/CUIDrawer';
import LoginSignupButtonsMobile from '../AuthButtons/LoginSignupButtonsMobile';
import I18n from 'I18n';
import CUIRouterLink from 'connect-dot-com-ui-components/Components/CUIRouterLink/CUIRouterLink';
import { getNavLinks } from '../../utils/navLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getActiveLinkColor = path => path === '/' ? 'CARNABY.regular' : 'GREYSCALE.ECLIPSE';
const Navigation = () => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  const {
    trackInteraction
  } = useContext(TrackerContext);
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const navLinks = getNavLinks();
  function trackHeaderClick(linkName) {
    trackInteraction('header nav click', {
      value: linkName
    });
  }
  return /*#__PURE__*/_jsx(CUIStack, {
    as: "nav",
    role: "navigation",
    align: "center",
    direction: "row",
    px: 4,
    gap: {
      base: 4,
      lg: 12
    },
    fontWeight: "500",
    children: isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LoginSignupButtonsMobile, {
        gap: 4
      }), /*#__PURE__*/_jsx(CUIButton, {
        name: "hamburger",
        "aria-label": I18n.text('app.homepage.header.menuIconAria'),
        onClick: onOpen,
        variant: "link",
        children: /*#__PURE__*/_jsx(CUIHamburgerIcon, {
          width: "20px",
          height: "20px"
        })
      }), /*#__PURE__*/_jsxs(CUIDrawer, {
        isOpen: isOpen,
        placement: "right",
        size: "full",
        onClose: onClose,
        children: [/*#__PURE__*/_jsx(CUIDrawerOverlay, {}), /*#__PURE__*/_jsx(MobileNavDrawerContent, {
          navLinks: navLinks,
          onClose: onClose,
          getActiveLinkColor: getActiveLinkColor,
          trackHeaderClick: trackHeaderClick
        })]
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CUIRouterLink, {
        color: getActiveLinkColor('/'),
        to: "/",
        onClick: () => trackHeaderClick('home'),
        fontSize: {
          base: 'sm',
          lg: 'md'
        },
        "data-test-id": "nav-home-link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connect.marketingSite.header.nav.home"
        })
      }), navLinks.map(link => /*#__PURE__*/_jsx(CUILink, {
        fontSize: {
          base: 'sm',
          lg: 'md'
        },
        href: link.path,
        color: getActiveLinkColor(link.path),
        onClick: () => trackHeaderClick(link.name),
        "data-test-id": link.dataTestId,
        children: link.component
      }, link.name))]
    })
  });
};
export default Navigation;